export default __webpack_public_path__ + "static/media/female@3x.572710b9.png";